import { append, body, hide } from "@acng/frontend-bounty";
export function createElement() {
    const element = document.createElement("ctx-srv");
    hide(element);
    append(body, element);
    return element;
}
